<div class="active-call-container">
  <div class="call-info">
    <div class="caller-avatar">
      <i class="material-icons">person</i>
    </div>
    <div class="caller-details">
      <p class="caller-number" *ngIf="callingPhoneNumber$ | async as number">
        {{ number }}
      </p>
      <h3 class="caller-name" *ngIf="callingPhoneName$ | async as name">
        {{ name }}
      </h3>
      <p class="call-duration">
        {{ callingTime | secondsToTime }}
      </p>
      <p class="call-status" *ngIf="onHold">
        Đang giữ cuộc gọi
      </p>
    </div>
  </div>

  <div class="call-controls">
    <button class="control-btn" [class.active]="showDTMF" title="Bàn phím" (click)="showDTMF = !showDTMF">
      <i class="material-icons">dialpad</i>
      <span class="control-label">Bàn phím</span>
    </button>
    <button class="control-btn" [class.active]="onRefer" title="Chuyển tiếp" (click)="referToggle()">
      <i class="material-icons">phone_forwarded</i>
      <span class="control-label">Chuyển</span>
    </button>
    <button class="control-btn" [class.active]="onHold" (click)="toggleHold()"
      title="{{onHold === false ? 'Giữ cuộc gọi' : 'Tiếp tục' }}">
      <i class="material-icons">{{onHold ? 'phone_in_talk' : 'phone_paused' }}</i>
      <span class="control-label">{{ onHold ? 'Tiếp tục' : 'Giữ' }}</span>
    </button>
    <button class="control-btn" [class.active]="isMuted" (click)="toggleMute()"
      title="{{ isMuted ? 'Bật tiếng' : 'Tắt tiếng' }}">
      <i class="material-icons">{{ isMuted ? 'mic_off' : 'mic' }}</i>
      <span class="control-label">{{ isMuted ? 'Bật mic' : 'Tắt mic' }}</span>
    </button>
    <button class="control-btn hangup-btn" (click)="hangup()" title="Ngắt cuộc gọi">
      <i class="material-icons">call_end</i>
      <span class="control-label">Kết thúc</span>
    </button>
  </div>

  <div class="call-controls" *ngIf="crm_url">
    <button class="control-btn" (click)="openTicket()" title="Xem phiếu">
      <i class="material-icons">confirmation_number</i>
      <span class="control-label">Phiếu</span>
    </button>
  </div>

  <ng-container *ngIf="onRefer">
    <div class="refer-section">
      <div class="refer-header">
        <span class="refer-title">Chuyển cuộc gọi</span>
      </div>
      <div class="refer-body">
        <mat-form-field color="accent" appearance="standard">
          <mat-label>Số chuyển tiếp</mat-label>
          <input autocomplete="off" matInput placeholder="Số chuyển tiếp" [(ngModel)]="referNumber">
        </mat-form-field>
        <div class="refer-actions">
          <button mat-raised-button (click)="referToggle()">
            <span class="d-flex align-items-center">Đóng <mat-icon aria-hidden="false">close</mat-icon></span>
          </button>
          <button class="text-white" mat-raised-button color="accent" (click)="confirmRefer()">
            <span class="d-flex align-items-center">Chuyển <mat-icon aria-hidden="false">forward</mat-icon></span>
          </button>
        </div>
      </div>
    </div>
  </ng-container>

  <div class="dtmf-pad" *ngIf="showDTMF">
    <div class="dtmf-grid">
      <button class="dtmf-btn" (click)="sendDTMF('1')">1</button>
      <button class="dtmf-btn" (click)="sendDTMF('2')">2</button>
      <button class="dtmf-btn" (click)="sendDTMF('3')">3</button>
      <button class="dtmf-btn" (click)="sendDTMF('4')">4</button>
      <button class="dtmf-btn" (click)="sendDTMF('5')">5</button>
      <button class="dtmf-btn" (click)="sendDTMF('6')">6</button>
      <button class="dtmf-btn" (click)="sendDTMF('7')">7</button>
      <button class="dtmf-btn" (click)="sendDTMF('8')">8</button>
      <button class="dtmf-btn" (click)="sendDTMF('9')">9</button>
      <button class="dtmf-btn" (click)="sendDTMF('*')">*</button>
      <button class="dtmf-btn" (click)="sendDTMF('0')">0</button>
      <button class="dtmf-btn" (click)="sendDTMF('#')">#</button>
    </div>
    <div class="dtmf-close">
      <button class="btn-close-dtmf" (click)="showDTMF = !showDTMF">Đóng</button>
    </div>
  </div>
</div>